import React from 'react';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import styles from './FeatureCard.module.css';

/**
 * FeatureCard - A reusable card component for feature displays
 * 
 * @param {Object} props Component props
 * @param {React.ReactNode} props.icon Icon element to display
 * @param {string} props.title Card title
 * @param {string} props.description Card description text
 * @param {string} props.buttonText Text for the action button
 * @param {Function} props.onClick Function to call when card or button is clicked
 * @returns {React.ReactElement} FeatureCard component
 */
const FeatureCard = ({ icon, title, description, buttonText, onClick }) => {
  return (
    <div 
      className={styles.featureCard} 
      onClick={onClick}
    >
      <div className={styles.cardIconContainer}>
        {icon}
      </div>
      <h3>{title}</h3>
      <p>{description}</p>
      
      <div className={styles.cardButtonContainer}>
        <button 
          className={styles.goToButton}
          onClick={(e) => {
            // Prevent double click events from bubbling
            e.stopPropagation(); 
            onClick && onClick(e);
          }}
        >
          <span className={styles.buttonText}>{buttonText}</span>
          <NavigateNextIcon fontSize="small" />
        </button>
      </div>
    </div>
  );
};

export default FeatureCard;